// https://www.typescriptlang.org/play?#code/KYOwrgtgBAygLgJwJYgOYFFzQN4CgoFQDyIwUAvFAEQD2pVANPoQCoDuNF1cHjuAvrlyhIUAHKQARsASZReQlBYALBMDKUAzE0UAxGmARcALDsIBZFGADOACTAgAJmsdcAtAEYADF6aDcAGYOAMZwSHRQchAA0sAAntYAFFEAXFAAhiBxAJRQCoRqcIYgxJIAVsChAHQA1vFJUdlVAUgANnAyiXVxFAB8UEjWYuliiQAO6QjWwACSIHBd8QxQ3tlrAkJBIKHhJVEAaumtYMANWGmZOXnMBIXFkVixCclYTRDpY4s95P1RANrdAC62Q2uGCdGsNFawCqrRoqBekCeSXgyDQjRB4JAkOhsPhiIgh2Op0SqJQGFeILBEKhMLhCKiyMSEgg0lklOp2NpeIZWCJJySLLZGKAA

export const enumKeys = (Enum: any) => {
  return Object.keys(Enum).filter(key => isNaN(parseInt(key, 10)));
}

export const enumValues = (Enum: any) => {
  return enumKeys(Enum).map(key => Enum[key]);
}
